import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=adb684e6&scoped=true"
var script = {}
import style0 from "./Accordion.scss?vue&type=style&index=0&id=adb684e6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb684e6",
  null
  
)

export default component.exports